import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { getBroadcast } from 'api/broadcasts.service';
import { useToast } from 'hooks/ui';
import { setDraftBroadcast, useBroadcastStore } from 'store/broadcast';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { DURATIONS } from 'common/constants';
import { useBroadcastById } from './useBroadcastGetAllQuery';
import { broadcastKeys } from './queryKeys';
import { AllStatuses } from 'interfaces';

export const useBroadcastGetQuery = (id: string) => {
  const draft = useBroadcastStore((store) => store.draft);
  const toast = useToast();
  const navigate = useNavigate();

  const isDraftSaved = draft.status !== AllStatuses.NOT_SAVED;

  const { data, isLoading, error } = useQuery({
    queryKey: broadcastKeys.broadcast(id),
    queryFn: () => getBroadcast(id),
    enabled: !!id,
    retry: false,
    refetchInterval: isDraftSaved && DURATIONS.MINUTES_1,
    initialData: useBroadcastById(id),
    refetchIntervalInBackground: isDraftSaved,
  });

  useEffect(() => {
    if (data) {
      setDraftBroadcast(data);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      navigate(broadcastRoutes.notFound, { replace: true });
      toast.error(error.message);
    }
  }, [error, toast, navigate]);

  return { isLoading, data };
};
